import { render, staticRenderFns } from "./CreatePostPhotos.vue?vue&type=template&id=47f6bcb7&"
import script from "./CreatePostPhotos.vue?vue&type=script&lang=js&"
export * from "./CreatePostPhotos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports